import React from "react";
import BusinessListingPage from "../../components/BusinessListingPage";
import { _get_discovery_trending } from "../../common/axios_services";
import { storePromoImages } from "../../common/promoConfig";

const Store = () => {
  return (
    <BusinessListingPage
      title=""
      bannerText="RETAIL STORES NEAR YOU"
      businessType="store"
      fetchBusinessesApi={_get_discovery_trending}
      promoImages={storePromoImages}
    />
  );
};

export default Store;
